var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.841 0C11.7533 -0.00251578 11.6655 0.00366899 11.579 0.0183443C5.77187 0.991543 1.50242 6.03583 1.5 11.9237C1.5 18.5772 6.92255 23.9995 13.5758 23.9995C17.3115 23.994 20.8381 22.2585 23.1199 19.3006C23.3415 19.014 23.4378 18.65 23.3869 18.2913C23.3359 17.9326 23.1421 17.6097 22.8496 17.3961C22.5569 17.1825 22.1903 17.0962 21.8332 17.157C21.3221 17.244 20.8029 17.2891 20.2844 17.2907C15.0822 17.2907 10.8935 13.1028 10.8922 7.90108V7.89836C10.8961 5.82146 11.5876 3.80575 12.8602 2.16452C13.0639 1.90246 13.1632 1.57415 13.139 1.24301C13.1146 0.91197 12.9685 0.601703 12.7288 0.372023C12.489 0.142457 12.1728 0.00995579 11.841 0ZM11.579 1.37284C9.61962 3.62284 9.3447 6.46752 9.34196 7.89836C9.34196 13.9502 12.75 18.75 21.75 18.75C20.246 19.7321 18 22.5 13.5 22.4995C8.29696 22.4995 3 17.2025 3 11.9995C3.00136 8.51225 5.25 3 11.579 1.37284Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.5e4f99297b2067b78c846fd15ea237a6.svg";
export { ForwardRef as ReactComponent };